import { render, staticRenderFns } from "./TileEvents.vue?vue&type=template&id=c8368954&"
import script from "./TileEvents.vue?vue&type=script&lang=js&"
export * from "./TileEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports